"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreateVenueVisitPlanRequestDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
class CreateVenueVisitPlanRequestDto {}
exports.CreateVenueVisitPlanRequestDto = CreateVenueVisitPlanRequestDto;
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.VenueVisitPlanTimeSlot
}), __metadata("design:type", String)], CreateVenueVisitPlanRequestDto.prototype, "timeSlot", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Calendar date (YYYY-MM-DD) to plan the visit for, in the venue\'s local timezone. ' + 'Must be within today through VENUE_VISIT_PLAN_MAX_DAYS_AHEAD days from today, inclusive.',
  example: '2026-09-20'
}), __metadata("design:type", String)], CreateVenueVisitPlanRequestDto.prototype, "plannedDate", void 0);
//# sourceMappingURL=CreateVenueVisitPlanRequest.dto.js.map